export enum SystemRole {
	Admin = "Admin",
	ReadOnly = "ReadOnly",
}

const rolePriorities: Record<SystemRole, number> = {
	[SystemRole.Admin]: 100,
	[SystemRole.ReadOnly]: 1,
}

/**
 * @returns A number value of the role's priority. Higher values indicate a higher level of role
 */
export function getRolePriority(role: SystemRole): number {
	return rolePriorities[role]
}
